export default function TimeSpentController() {}
